import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import {
  ATL,
  BBTL,
  BTL,
  SATL,
  TIER_TYPES_MAP,
  ZTL
} from "MODULES/parts/constants";
import Warning from "MODULES/shared/components/Warning/Warning";
import api from "APP_ROOT/api";
import { hasBasename } from "history/PathUtils";
import {
  DO_NOT_LIST,
  INSPECTED,
  LIST,
  REPAIRED
} from "MODULES/inventories/constants";
import {
  BENCH_TEST,
  OVERHAUL,
  OVERHAULED,
  REPAIR
} from "MODULES/RepairOrders/constants";

const ACTION_CONDITION_MAPPING = {
  [BENCH_TEST]: INSPECTED,
  [REPAIR]: REPAIRED,
  [OVERHAUL]: OVERHAULED
};

export default function InternalOutrightConsiderationWarning({
  actionRequested,
  condition,
  inventoryId,
  outrightValue,
  originalEval,
  partId,
  tierType
}) {
  const [matchedInventory, setMatchedInventory] = useState(null);

  if (![BENCH_TEST, REPAIR, OVERHAUL].includes(actionRequested)) return null;

  useEffect(
    () => {
      api.inventories
        .search({
          exclude_inventory_id: inventoryId,
          matching_condition: ACTION_CONDITION_MAPPING[actionRequested],
          part_id: partId,
          ranking: true,
          sort: "id",
          sellable_status: [LIST, DO_NOT_LIST].join(","),
          limit: 1
        })
        .then(res => {
          setMatchedInventory(res.data.results[0]);
        })
        .catch(() => setMatchedInventory(null));

      return function cleanup() {};
    },
    [inventoryId, partId, condition]
  );

  const margin = Math.abs(
    parseFloat(originalEval) / parseFloat(outrightValue) * 100 - 100
  );

  const inventorySrp = matchedInventory && matchedInventory.suggested_retail;

  const withinTenPercent = () =>
    inventorySrp &&
    Math.abs(parseFloat(originalEval) / parseFloat(inventorySrp) * 100 - 100) <
      10;

  const marginBrackets = { ATL: 10, BTL: 20, BBTL: 30, SATL: 10, ZTL: 40 };

  let warningText = `This item qualifies for ${TIER_TYPES_MAP[
    tierType
  ]} and original evaluation is within
    ${marginBrackets[tierType]}% of Outright Value.`;
  let showWarning = false;

  const hasTierType = [ATL, BTL, BBTL, SATL, ZTL].includes(tierType);

  if (hasTierType && margin <= marginBrackets[tierType]) {
    showWarning = true;
  } else if (!hasBasename && margin <= 50) {
    showWarning = true;
    warningText = `This item does not qualify at any Tier and the original evaluation is within
      50% of Outright Value.`;
  }

  if (withinTenPercent() && !showWarning) {
    showWarning = true;

    warningText = hasTierType
      ? `This item qualifies for ${TIER_TYPES_MAP[
          tierType
        ]} and original evaluation is within 10% of next matching condition SRP.`
      : `This item does not qualify at any Tier and is within 10% of the next matching condition SRP.`;
  }

  if (!showWarning) return null;

  return (
    <div className="row m-r-10">
      <Col sm={12}>
        <Warning>
          {`${warningText}  This item should be considered for Internal Outright.`}
        </Warning>
      </Col>
    </div>
  );
}

InternalOutrightConsiderationWarning.propTypes = {
  actionRequested: PropTypes.string.isRequired,
  condition: PropTypes.string.isRequired,
  inventoryId: PropTypes.number,
  partId: PropTypes.number.isRequired,
  outrightValue: PropTypes.number.isRequired,
  originalEval: PropTypes.number.isRequired,
  tierType: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ActionRequested/InternalOutrightConsiderationWarning.jsx